import React from "react";
import "./ourSolution.css";
import Rectangle31 from "assets/realEstateCRM-image/Rectangle31.png";
import buttonArrow from "assets/realEstateCRM-image/button-arrow.svg";
import thirdPartyIcon from "assets/home/third_party_icon.svg";
import customizationIcon from "assets/home/customization_icon.svg";
import projectIcon from "assets/home/project_icon.svg";
import { useNavigate } from "react-router-dom";

const OurSolution = () => {
  const navigate = useNavigate();

  const handleOurSolution = (e) => {
    e.preventDefault();
    navigate("../our-solutions");
  };

  return (
    <div className="our-solution--outer">
      <div className="container">
        <div className="our-solution-row">
          <div className="text-col">
            <button className="title-button title-button--primary">Our Solutions</button>
            <h3>
              Why choose Realtor CRM for <br />
              your real estate business?
            </h3>
            <p className="left-align-text">
              Realtor CRM is designed to streamline every aspect of your real
              estate business. From managing properties and automating sales
              processes to building strong client relationships, it offers a
              user-friendly platform tailored to your needs. With powerful
              analytics, mobile access, and exceptional support, Realtor CRM
              empowers agencies of all sizes to close deals faster and grow
              effortlessly.
            </p>
            <div onClick={handleOurSolution} className="tcl-button--outer tcl-button--start">
              <button className="tcl-button tcl-button--primary">Learn More</button>
              <div className="realEstateCRM-arrow">
                <img src={buttonArrow} alt="GET START" />
              </div>
            </div>
          </div>
          <div className="img-col">
            <img src={Rectangle31} alt="Nothing"></img>
          </div>
        </div>
        <div className="features-row">
          <div className="feature-box">
            <div className="feature-icon">
              <img src={thirdPartyIcon} alt="Third-Party integrations" />
            </div>
            <h3>Third-Party Integrations</h3>
            <p>
              Realtor CRM seamlessly connects with popular tools like email,
              marketing platforms, and property listing services, ensuring a
              unified and efficient workflow.
            </p>
          </div>
          <div className="feature-box">
            <div className="feature-icon">
              <img src={customizationIcon} alt="Complete Customization" />
            </div>
            <h3>Complete Customization</h3>
            <p>
              Realtor CRM offers fully customizable features, allowing you to
              tailor workflows, fields, and settings to match your business needs
              and processes.
            </p>
          </div>
          <div className="feature-box">
            <div className="feature-icon">
              <img src={projectIcon} alt="Project Management" />
            </div>
            <h3>Project Management</h3>
            <p>
              Realtor CRM simplifies project management with tools to track tasks,
              deadlines, and team progress, ensuring efficient execution and
              successful outcomes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurSolution;
